import React from 'react';
import PropTypes from 'prop-types';
import { CccisdFieldWrapper } from 'cccisd-formik';
import classnames from 'classnames';

const ButtonGroup = props => {
    const { field, options, form } = props;

    return (
        <CccisdFieldWrapper {...props}>
            <div>
                <div className="btn-group" role="group" aria-label="Basic radio toggle button group">
                    {options.map(option => (
                        <button
                            key={option.value}
                            type="button"
                            className={classnames(
                                'btn',
                                option.value === field.value ? 'btn-primary' : 'btn-outline-primary'
                            )}
                            onClick={() => form.setFieldValue(field.name, option.value)}
                        >
                            {option.label}
                        </button>
                    ))}
                </div>
            </div>
        </CccisdFieldWrapper>
    );
};

ButtonGroup.propTypes = {
    field: PropTypes.object,
    options: PropTypes.array.isRequired,
    onChange: PropTypes.func,
};

export default ButtonGroup;
